"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var ErrorMessageProvider_1 = require("../../Atoms/ErrorMessageProvider/ErrorMessageProvider");
var makeErrorMessageStyles_1 = __importDefault(require("./makeErrorMessageStyles"));
var react_2 = require("@emotion/react");
var ErrorMessage = function () {
    var errorMessage = (0, ErrorMessageProvider_1.useErrorMessage)().errorMessage;
    var theme = (0, react_2.useTheme)();
    if (errorMessage) {
        return ((0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ css: (0, makeErrorMessageStyles_1.default)(theme), "data-testid": "errorMessage" }, { children: errorMessage })));
    }
    return (0, jsx_runtime_1.jsx)(react_1.Fragment, {});
};
exports.default = ErrorMessage;
//# sourceMappingURL=ErrorMessage.js.map